export const SDK_SEASON = 2024
